<template>
    <div>
        <div>
            <div class="jumbotron"></div>
        </div>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 JY-about">
                        <h2><em></em>新用户注册<span><em>Sign Up</em></span></h2>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto JY-signUp-nav">
                        <li><a :class="currentStep=='step1'?'sel':''" href="javascript:;"><em></em>选择身份</a></li>
                        <li><a :class="currentStep=='step2'?'sel':''" href="javascript:;">填写资料</a></li>
                        <li><a :class="currentStep=='step3'?'sel':''" href="javascript:;">注册成功</a></li>
                    </div>
                </div>
                <div v-if="currentStep=='step1'" class="step1">
                    <div class="row">
                        <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto JY-sign-cont">
                            <li @click="chooseUserType(0)" :class="userModel.UserType==0?'sel':''"><i><img src="../assets/images/sign-icona-a.png" width="60" height="60" alt=""/></i>
                                <h4>货主</h4>
                                <p>需要发货的个人或企业，可免费发布货物运输信息。</p>
                            </li>
                            <li @click="chooseUserType(1)" :class="userModel.UserType==1?'sel':''"><i><img src="../assets/images/sign-icona-b.png" width="60" height="60" alt=""/></i>
                                <h4>承运人</h4>
                                <p>提供物流运输服务且具备营运资格的车队或个体车主，可免费注册和管理车辆接单信息。</p>
                            </li>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto text-center">
                            <button type="button" @click="gotoStep2()" class="btn btn-primary">下一步</button>
                        </div>
                    </div>
                </div>
                <div v-if="currentStep=='step2'" class="step2">
                    <div class="row">
                        <div class="col-lg-4 col-sm-12 mb-4 mt-2s ml-auto mr-auto JY-sign-cont-b">
                            <h4 class="text-center mt-4 mb-5">基本信息</h4>
                            <form>
                                <el-alert v-if="!allowSubmit" :title="errorMessage" type="error">
                                </el-alert>
                                <div class="form-group">
                                    <label for="exampleInputEmail1"><strong>登录名（登录账户）</strong><font class="fn-color-red">*</font></label>
                                    <input type="text" @blur="checkUserLoginName" v-model="userModel.UserLoginName" class="form-control  input-sm" placeholder="请输入登录名">
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputEmail1"><strong>真实姓名</strong><font class="fn-color-red">*</font></label>
                                    <input type="text" v-model="userModel.UserName" class="form-control  input-sm" placeholder="请输入您的真实姓名">
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputEmail1"><strong>手机号码</strong><font class="fn-color-red">*</font></label>
                                    <input type="number" v-model="userModel.Mobile" class="form-control  input-sm" placeholder="">
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputEmail1" style="display: block;"><strong>短信验证码(有效期十分钟)</strong><font class="fn-color-red">*</font></label>
                                    <input type="text" v-model="userModel.SMSCode" class="form-control  input-sm" style="width: 67%; display: inline-block" placeholder="">
                                    <button type="button" @click="sendSMSCode()" :disabled="sended" class="btn btn-info" style="margin-top: -5px; margin-left: 9px">{{sended?'已经发送':'获取验证码'}}</button>
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputEmail1"><strong>登录密码</strong><font class="fn-color-red">*</font></label>
                                    <input type="password" v-model="userModel.Password" class="form-control  input-sm" placeholder="请设置密码至少6位以上">
                                </div>
                                <div class="form-group">
                                    <label for="exampleInputEmail1"><strong>再次输入密码</strong><font class="fn-color-red">*</font></label>
                                    <input type="password" v-model="userModel.ConformPassword" class="form-control  input-sm" placeholder="请再次输入密码">
                                </div>
                            </form>
                            <p class="text-center mt-3" style="position: relative;">
                                <el-checkbox v-model="userModel.Agree" label="同意"></el-checkbox><a href="javascript:;" @click="openCondition">嘉盈吉运无车承运人物流平台服务协议</a>
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto text-center">
                            <button type="button" @click="gotoStep1()" class="btn btn-primary">上一步</button>
                            <button type="button" :disabled="!userModel.Agree" style="margin-left:10px;" @click="gotoStep3()" class="btn btn-primary">提交</button>
                        </div>
                    </div>
                </div>
                <div v-if="currentStep=='step3'" class="step3">
                    <div class="row">
                        <div class="col-lg-12 col-sm-12 mb-4 mt-2s ml-auto mr-auto JY-sign-cont-fin">
                            <h4 class="text-center mt-4 mb-5">恭喜您，注册成功！</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-sm-12 mb-4 mt-2s ml-auto mr-auto text-center">
                            <!-- <button type="button" class="btn btn-primary">返回首页</button> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <el-dialog title="使用条款" :visible.sync="conditionDialogVisible" width="70%" center>
            <condition :id="conditionId"></condition>
        </el-dialog>
    </div>
</template>
<script>
    import api from "../api";
    import util from "../libs/util";
    import condition from '../components/condition'
    export default {
        components: {
            condition
        },
        data() {
            return {
                conditionDialogVisible: false,
                conditionId: '',
                currentStep: "step1",
                sended: false,
                smsCode: "",
                allowSubmit: true,
                errorMessage: '',
                userModel: {
                    UserType: 0
                }
            };
        },
        methods: {
            openCondition() {
                this.conditionId = 'ee0b04b1-0059-4af7-9761-b730c8ba0218'
                this.conditionDialogVisible = true
            },
            checkUserLoginName() {
                let _this = this;
                api.checkUserLoginName({
                    name: _this.userModel.UserLoginName
                })
                .then(res => {
                    _this.allowSubmit = res.data.Succeed
                    if (!res.data.Succeed) {
                        _this.errorMessage = res.data.Message
                    }
                });
            },
            sendSMSCode() {
                let _this = this;
                if (!/^1\d{10}$/.test(_this.userModel.Mobile)) {
                    _this.$message({
                        message: "请输入正确的手机号",
                        type: "error"
                    });
                    return;
                }
                api.sendSMSCode({
                    mobile: _this.userModel.Mobile
                })
                .then(res => {
                    if (res.data.Succeed) {
                        _this.sended = true;
                        _this.smsCode = res.data.Data;
                    } else {
                        _this.$message({
                            message: res.data.Message,
                            type: "error"
                        });
                    }
                });
            },
            chooseUserType(userType) {
                this.$set(this.userModel, "UserType", userType);
            },
            gotoStep1() {
                this.currentStep = "step1";
            },
            gotoStep2() {
                this.currentStep = "step2";
            },
            gotoStep3() {
                let _this = this;
                if (_this.smsCode != _this.userModel.SMSCode) {
                    _this.$message({
                        message: "验证码不正确",
                        type: "error"
                    });
                    return;
                }
                if(_this.userModel.Password.length<6){
                    _this.$message({
                        message: "密码长度太短",
                        type: "error"
                    });
                    return;
                }
                if (!_this.allowSubmit) return;
                api.RegistUser(_this.userModel).then(res => {
                    if (res.data.Succeed) {
                        this.currentStep = "step3";
                        setTimeout(() => {
                            _this.autoLogin()
                        }, 2000);
                    } else {
                        _this.$message({
                            message: res.data.Message,
                            type: "error"
                        });
                    }
                });
            },
            autoLogin() {
                let _this = this
                api
                    .createToken({
                        mobile: _this.userModel.Mobile,
                        pwd: _this.userModel.Password
                    })
                    .then(res => {
                        if (res.data.Succeed) {
                            util.cookies.set("access_token", res.data.Token);
                            util.cookies.set("usertype", res.data.UserType);
                            _this.$router.push('profile');
                            window.location.reload();
                        }
                    });
            }
        }
    };
</script>
<style>
    .jumbotron {
        background: url(../assets/images/real2.jpg) no-repeat;
        background-size: cover;
        min-height: 200px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Register.vue